module.exports = __webpack_public_path__ + "assets/img/Accountanalysis.06f6ab5b.png";